import "./single.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const Single = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.pathname.split("/")[2];

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editedUser, setEditedUser] = useState({
    username: "",
    email: "",
  });
  const [isEditMode, setIsEditMode] = useState(false); // Toggle for edit mode

  // Fetch user data when component is mounted
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://api.mecdistanceeducation.com/api/users/${id}`
        );
        setData(response.data);
        setEditedUser({
          username: response.data.username,
          email: response.data.email,
        });
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch user data");
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleChange = (e) => {
    setEditedUser({
      ...editedUser,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("access_token");
      const res = await axios.put(
        `https://api.mecdistanceeducation.com/api/users/${id}`,
        editedUser,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status === 200) {
        console.log("User updated successfully");
        navigate("/users"); // Navigate to the users list after update
        setIsEditMode(false); // Exit edit mode after updating
      } else {
        console.log("Failed to update user");
      }
    } catch (err) {
      console.log("Error updating user:", err);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <h1 className="title">User Information</h1>
            <div
              className="editButton"
              onClick={() => setIsEditMode(!isEditMode)}
            >
              {isEditMode ? "Cancel" : "Edit"}
            </div>
            {/* <div className="editButton">
              <button onClick={() => setIsEditMode(!isEditMode)}>
              {isEditMode ? "Cancel" : "Edit"}
            </button>
            </div>  */}
            <div className="item">
              <img src={data.img} alt="" className="itemImg" />
              <div className="details">
                {isEditMode ? (
                  // Edit mode with form for username and email
                  <form onSubmit={handleUpdate}>
                    <div className="detailItem">
                      <label className="itemKey">Username:</label>
                      <input
                        type="text"
                        className="itemValue"
                        name="username"
                        value={editedUser.username}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="detailItem">
                      <label className="itemKey">Email:</label>
                      <input
                        type="email"
                        className="itemValue"
                        name="email"
                        value={editedUser.email}
                        onChange={handleChange}
                      />
                    </div>
                    <button type="submit">Save</button>
                  </form>
                ) : (
                  // View mode, display only username and email
                  <div>
                    <div className="detailItem">
                      <span className="itemKey">Id:</span>
                      <span className="itemValue">{data._id}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Username:</span>
                      <span className="itemValue">{data.username}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Email:</span>
                      <span className="itemValue">{data.email}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Courses:</span>
                      <span className="itemValue">
                        {data.courses.length > 0
                          ? data.courses.map((courseId, index) => (
                              <span key={index}>
                                {/* Display course ID or course name if you have a mapping */}
                                {courseId}{" "}
                                {/* Replace with course name if available */}
                                {index < data.courses.length - 1 && ", "}
                              </span>
                            ))
                          : "No courses assigned"}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* <button onClick={() => setIsEditMode(!isEditMode)}>
              {isEditMode ? "Cancel" : "Edit"}
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Single;
